module.exports = __webpack_public_path__ + "static/media/telehealthservicesicon.173b1767.svg";